import { BaseReducerState, Bill, FetchBillResponse } from '../../../services'
import { ActionTypes } from './actions'
import { SitesRentReportAPIResponse } from './types'

export type SitesRentReportState = BaseReducerState & {
  data: [Bill]
}

export const initialState: SitesRentReportState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const sitesRentReportState = (
  state: SitesRentReportState = initialState,
  action: { type: string; res: any }
): SitesRentReportState => {
  switch (action.type) {
    case `${ActionTypes.GET_SITES_RENT_DATA}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_SITES_RENT_DATA}_SUCCESS`: {
      const { success, data, message } = <SitesRentReportAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_SITES_RENT_DATA}_FAILURE`:
      const res = <SitesRentReportAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_SITES_RENT_DATA}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
